<template>
  <section class="serve-customers">
    <div class="container">
      <!-- Section Header -->
      <div class="section-header">
        <h2 class="section-title">服务客户</h2>
        
        <!-- Center Decor Element -->
        <div class="center-decor">
          <div class="line"></div>
          <div class="dot"></div>
          <div class="line active"></div>
          <div class="dot"></div>
          <div class="line"></div>
        </div>
      </div>

      <!-- Customers Grid -->
      <div class="customers-grid">
        <!-- Card 1 -->
        <div class="customer-card">
          <div class="icon-wrapper">
            <img src="../assets/ServeCustomersSection/1.png" alt="央企" @error="handleImageError" />
          </div>
          <h3 class="card-title">央企</h3>
          <p class="card-desc">服务大型央企集团，<br>支撑核心业务数字化升级。</p>
          <div class="card-bg card-bg-1"></div>
        </div>

        <!-- Card 2 -->
        <div class="customer-card">
          <div class="icon-wrapper">
            <img src="../assets/ServeCustomersSection/2.png" alt="政府机构" @error="handleImageError" />
          </div>
          <h3 class="card-title">政府机构</h3>
          <p class="card-desc">赋能政府数字化管理，<br>提升政务服务效能。</p>
          <div class="card-bg card-bg-2"></div>
        </div>

        <!-- Card 3 -->
        <div class="customer-card">
          <div class="icon-wrapper">
            <img src="../assets/ServeCustomersSection/3.png" alt="事业单位" @error="handleImageError" />
          </div>
          <h3 class="card-title">事业单位</h3>
          <p class="card-desc">助力事业单位高效运营，<br>推动公共服务创新。</p>
          <div class="card-bg card-bg-3"></div>
        </div>

        <!-- Card 4 -->
        <div class="customer-card">
          <div class="icon-wrapper">
            <img src="../assets/ServeCustomersSection/4.png" alt="高校" @error="handleImageError" />
          </div>
          <h3 class="card-title">高校</h3>
          <p class="card-desc">赋能高校智慧校园建设，<br>提升教学与科研管理效能。</p>
          <div class="card-bg card-bg-4"></div>
        </div>
      </div>

      <!-- Footer Text -->
      <div class="section-footer">
        <div class="footer-decor">
          <span class="dot"></span>
          <div class="line"></div>
        </div>
        <p class="footer-text">
          累计服务 <span class="highlight">300+</span> 客户，项目经验丰富，值得信赖
        </p>
        <div class="footer-decor">
          <div class="line"></div>
          <span class="dot"></span>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: 'ServeCustomersSection',
  methods: {
    handleImageError(e) {
      e.target.src = 'data:image/svg+xml;utf8,<svg xmlns="http://www.w3.org/2000/svg" width="120" height="120" fill="%23e4ecf7"><rect width="120" height="120" rx="20"/></svg>';
    }
  }
}
</script>

<style scoped>
.serve-customers {
  padding: 80px 0 100px;
  background: linear-gradient(180deg, #f4f8ff 0%, #eef3fc 100%);
  position: relative;
  overflow: hidden;
}

/* Optional: faint background wave effect to match screenshot */
.serve-customers::before {
  content: "";
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 400px;
  background-image: radial-gradient(ellipse at 50% 150%, rgba(255, 255, 255, 0.4) 0%, transparent 70%);
  pointer-events: none;
  z-index: 0;
}

.container {
  max-width: 1400px;
  margin: 0 auto;
  padding: 0 clamp(20px, 4vw, 40px);
  position: relative;
  z-index: 1;
}

/* Header Styles */
.section-header {
  text-align: center;
  margin-bottom: 60px;
}

.section-title {
  font-size: clamp(24px, 3vw, 36px);
  color: #111;
  font-weight: 800;
  letter-spacing: 2px;
  margin-bottom: 16px;
}

.center-decor {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
}

.center-decor .line {
  height: 2px;
  background: rgba(0, 82, 217, 0.2);
}

.center-decor .line:nth-child(1),
.center-decor .line:nth-child(5) {
  width: 40px;
}

.center-decor .line.active {
  width: 40px;
  height: 4px;
  background: #0052d9;
  border-radius: 2px;
}

.center-decor .dot {
  width: 4px;
  height: 4px;
  background-color: rgba(0, 82, 217, 0.4);
  border-radius: 50%;
}

/* Grid Styles */
.customers-grid {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 24px;
  margin-bottom: 60px;
}

/* Card Styles */
.customer-card {
  background-color: #ffffff;
  border-radius: 16px;
  padding: 50px 20px 40px;
  text-align: center;
  box-shadow: 0 10px 30px rgba(0, 82, 217, 0.04);
  transition: all 0.4s cubic-bezier(0.165, 0.84, 0.44, 1);
  position: relative;
  overflow: hidden;
  border: 1px solid rgba(255, 255, 255, 0.5);
}

.customer-card::before {
  content: '';
  position: absolute;
  top: 0;
  left: -100%;
  width: 100%;
  height: 100%;
  background: linear-gradient(90deg, transparent, rgba(0, 82, 217, 0.04), transparent);
  transition: left 0.6s ease;
  pointer-events: none;
  z-index: 3;
}

.customer-card:hover::before {
  left: 100%;
}

.customer-card:hover {
  transform: translateY(-10px);
  box-shadow: 0 20px 40px rgba(0, 82, 217, 0.1);
}

.icon-wrapper {
  width: 140px;
  height: 140px;
  margin: 0 auto 24px;
  position: relative;
  z-index: 2;
  display: flex;
  align-items: center;
  justify-content: center;
}

.icon-wrapper img {
  max-width: 100%;
  max-height: 100%;
  object-fit: contain;
  transition: transform 0.4s ease;
}

.customer-card:hover .icon-wrapper img {
  transform: scale(1.05) translateY(-5px);
}

.card-title {
  font-size: 22px;
  color: #111;
  font-weight: 700;
  margin-bottom: 16px;
  position: relative;
  z-index: 2;
}

.card-desc {
  font-size: 14px;
  color: #666;
  line-height: 1.8;
  margin: 0;
  position: relative;
  z-index: 2;
}

/* Card Background Silhouettes using faint SVG data URIs */
.card-bg {
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 100px;
  background-size: 100% 100%;
  background-repeat: no-repeat;
  background-position: bottom;
  opacity: 0.5;
  z-index: 1;
  pointer-events: none;
  transition: opacity 0.4s ease;
}

.customer-card:hover .card-bg {
  opacity: 0.8;
}

/* Faint generic city silhouette for cards */
.card-bg-1, .card-bg-3 {
  background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 300 100' preserveAspectRatio='none'%3E%3Cpath fill='%23eaf0fa' d='M0,100 L0,70 L20,70 L20,50 L40,50 L40,60 L50,60 L50,30 L80,30 L80,45 L100,45 L100,20 L130,20 L130,55 L160,55 L160,40 L190,40 L190,65 L220,65 L220,35 L250,35 L250,75 L280,75 L280,60 L300,60 L300,100 Z'/%3E%3C/svg%3E");
}

/* Faint government/university style silhouette */
.card-bg-2, .card-bg-4 {
  background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 300 100' preserveAspectRatio='none'%3E%3Cpath fill='%23eaf0fa' d='M0,100 L0,80 L40,80 L40,60 L80,60 L80,40 L110,40 L110,30 L190,30 L190,40 L220,40 L220,60 L260,60 L260,80 L300,80 L300,100 Z'/%3E%3C/svg%3E");
}

/* Footer Text Styles */
.section-footer {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 20px;
}

.footer-decor {
  display: flex;
  align-items: center;
  gap: 8px;
}

.footer-decor .dot {
  width: 6px;
  height: 6px;
  background-color: #0052d9;
  border-radius: 50%;
}

.footer-decor .line {
  width: 60px;
  height: 1px;
  background: linear-gradient(to right, rgba(0, 82, 217, 0.8), transparent);
}

.footer-decor:last-child .line {
  background: linear-gradient(to left, rgba(0, 82, 217, 0.8), transparent);
}

.footer-text {
  font-size: 20px;
  color: #333;
  font-weight: 600;
  margin: 0;
  letter-spacing: 1px;
}

.footer-text .highlight {
  font-size: 32px;
  color: #0052d9;
  font-weight: 800;
  margin: 0 4px;
}

/* Responsive adjustments */
@media (max-width: 1200px) {
  .customers-grid {
    grid-template-columns: repeat(2, 1fr);
    row-gap: 30px;
  }
}

@media (max-width: 768px) {
  .customers-grid {
    grid-template-columns: repeat(1, 1fr);
  }
  .section-footer {
    flex-direction: column;
    text-align: center;
  }
  .footer-decor {
    display: none;
  }
}

@media (max-width: 600px) {
  .serve-customers {
    padding: 48px 0 48px;
  }
  .section-header {
    margin-bottom: 36px;
  }
  .customers-grid {
    gap: 16px;
  }
  .customer-card {
    padding: 32px 16px 28px;
  }
  .icon-wrapper {
    width: 90px;
    height: 90px;
    margin-bottom: 16px;
  }
  .card-title {
    font-size: 18px;
    margin-bottom: 10px;
  }
  .card-desc {
    font-size: 13px;
  }
  .footer-text {
    font-size: 15px;
  }
  .footer-text .highlight {
    font-size: 22px;
  }
}
</style>